<template>
  <!-- <v-select
    label="Forma de Pagamento"
    :items="payment_types"
    item-text="description"
    item-value="id"
    @input="handleInput"
    :value="value"
    v-bind="$attrs"
  ></v-select> -->
  <v-radio-group
    @change="handleInput"
    :value="value"
    v-bind="$attrs"
    label="Forma de Pagamento"
    column
    :name="name"
  >
    <v-radio
      v-for="item in payment_types"
      :key="item.id"
      :label="item.description"
      :value="item.id"
    >
    </v-radio>
  </v-radio-group>
</template>

<script>
import { index } from "@/services/payment_types";

export default {
  name: "payment-type-picker",
  props: {
    value: {
      type: Number,
      default: null,
    },
    name: {
      type: String,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data: () => ({
    payment_types: [],
  }),
  methods: {
    async getItems() {
      const response = await index();
      this.payment_types = response;
    },
    handleInput(value) {
      this.$emit("change", value);
    },
  },
  created() {
    this.getItems();
  },
};
</script>